import { LogOut } from 'lucide-react'
import type { ReactElement } from 'react'
import { useMe } from '@/auth/queries'
import { useSignOut } from '@/auth/use-sign-out'
import { ModeToggle } from '@/components/mode-toggle'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'

type AdminAccountSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AdminAccountSheet({
  open,
  onOpenChange,
}: AdminAccountSheetProps): ReactElement {
  const me = useMe()
  const { signOut, isPending } = useSignOut()

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="mx-auto max-w-md">
        <SheetHeader>
          <SheetTitle>{me.data?.name ?? 'Account'}</SheetTitle>
          <SheetDescription>{me.data?.email}</SheetDescription>
        </SheetHeader>
        <div className="flex items-center justify-between px-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
          <ModeToggle />
          <Button variant="outline" onClick={signOut} disabled={isPending}>
            <LogOut aria-hidden="true" className="mr-2 size-4" />
            Sign out
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}
